

const serveradr = 'server.ipmdevelop.cz'
// const serveradr = '192.168.10.70'

module.exports = {
    serveradr: serveradr
};
